import { css } from "@compiled/react";
import { FormattedMessage, useIntl } from "react-intl";

import Lozenge from "@atlaskit/lozenge";

import { getTemplateType } from "@/components/confluence/templates/util/template-util";
import { Template, TemplateType } from "@/content/templates/template.types";

export type TemplateCategorySectionProps = {
    template: Template;
};

const templateCategorySectionStyles = css({
    display: "flex",
    flexDirection: "column"
});

const headingStyles = css({
    color: "#505F79",
    fontSize: ".75rem",
    fontWeight: 400,
    letterSpacing: "1px",
    marginBlockEnd: "24px",
    marginBlockStart: "28px"
});

const categoryContainerStyles = css({
    display: "inline-flex",
    height: "32px",
    paddingBlockEnd: "16px"
});

export const TemplateCategorySection = ({
    template
}: TemplateCategorySectionProps) => {
    const intl = useIntl();

    const categoryText = intl.formatMessage({
        id: "ConfluenceTemplateMessages.categories.heading",
        defaultMessage: "CATEGORIES"
    });

    const categories = template.category || [];

    const experimentCategories = categories.filter(
        (category) =>
            category.urlSlug === "recommended" ||
            category.urlSlug === "project-management" ||
            category.urlSlug === "software-development-and-it" ||
            category.urlSlug === "product-management" ||
            category.urlSlug === "marketing-and-sales" ||
            category.urlSlug === "design" ||
            category.urlSlug === "finance-and-operations" ||
            category.urlSlug === "human-resources"
    );

    const templateType = getTemplateType(template);

    return (
        <section css={templateCategorySectionStyles}>
            <h1 css={headingStyles}>{categoryText}</h1>
            {experimentCategories.map((category) => (
                <div key={category.id} css={categoryContainerStyles}>
                    <Lozenge appearance="inprogress">{category.name}</Lozenge>
                </div>
            ))}
            <div key={templateType.type} css={categoryContainerStyles}>
                <Lozenge
                    appearance={
                        templateType.type === TemplateType.Page
                            ? "inprogress"
                            : "success"
                    }
                    isBold
                >
                    <FormattedMessage
                        id="confluence.templates.detail.template.type"
                        defaultMessage={`{templateType} template`}
                        values={{ templateType: templateType.label }}
                    />
                </Lozenge>
            </div>
        </section>
    );
};
